import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { authService } from '../../services/authService';

export const useGetTwoFactorOtpStatus = options => {
  return useQuery({
    queryKey: [QUERY_KEYS.auth.two_factor_otp_status],
    queryFn: () =>
      authService.twoFactorOtpStatus().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        if (status === 401) {
          options?.onTokenExpired && options.onTokenExpired();
        }
        throw new Error('Fetch failed');
      }),
  });
};
